import { DictionaryActionTypes } from 'state/actions/dictionary';
import { IReducerAction } from 'models/context';
import { IDictionary } from 'models/dictionary';

interface IState {
  phoneCode: IDictionary[] | null;
  civilianPrefix: IDictionary[] | null;
  gender: IDictionary[] | null;
  make: IDictionary[] | null;
  maritalStatus: IDictionary[] | null;
  identificationDocumentType: IDictionary[] | null;
  nationalityAll: IDictionary[] | null;
}

export const initialState: IState = {
  phoneCode: null,
  civilianPrefix: null,
  gender: null,
  make: null,
  maritalStatus: null,
  identificationDocumentType: null,
  nationalityAll: null,
};

export const reducer = (state: IState, { type, payload }: IReducerAction) => {
  switch (type) {
    case DictionaryActionTypes.SET_PHONE_CODE: {
      return { ...state, phoneCode: payload };
    }
    case DictionaryActionTypes.SET_CIVILIAN_PREFIX: {
      return { ...state, civilianPrefix: payload };
    }
    case DictionaryActionTypes.SET_GENDER: {
      return { ...state, gender: payload };
    }
    case DictionaryActionTypes.SET_MAKE: {
      return { ...state, make: payload };
    }
    case DictionaryActionTypes.SET_MARITAL_STATUS: {
      return { ...state, maritalStatus: payload };
    }
    case DictionaryActionTypes.SET_IDENTIFICATION_DOCUMENT_TYPE: {
      return { ...state, identificationDocumentType: payload };
    }
    case DictionaryActionTypes.SET_NATIONALITY_ALL: {
      return { ...state, nationalityAll: payload };
    }

    default:
      return state;
  }
};
